import React from "react";
import { Col, Row } from "react-bootstrap";
import HireUsModal from "./HireUsModal";
import NavbarComponent from "./NavbarComponent";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const words = ["LMS", "HMS", "ERP", "CRM"];

function TopBgComponent() {
  return (
    <motion.div className="background" id="home">
      <div className="overlay">
        <div className="container">
          <NavbarComponent />
          <div className="flex-top">
            <Row className="w-100">
              <Col xs={12} md={6} className="hero-badge-col">
                <motion.div
                  initial={{ opacity: 0, x: -60 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="hero-left"
                >
                  <div className="ai-badge">
                    <span className="ai-dot" />
                    AI-Powered Enterprise Software
                  </div>
                  <h1 className="hero-title">
                    Intelligent Systems <br />
                    <motion.span
                      initial={{ color: "#ffffff", opacity: 0 }}
                      animate={{ color: "#63FFCD", opacity: 1 }}
                      transition={{ duration: 0.8, delay: 0.6 }}
                      className="hero-accent"
                    >
                      Built For You
                    </motion.span>
                  </h1>
                  <p className="hero-desc">
                    From Learning Management to Hospital Systems & ERP — we deliver
                    fully AI-powered, customized software in{" "}
                    <strong style={{ color: "#63FFCD" }}>24 hours</strong>.
                    Try any product <strong style={{ color: "#63FFCD" }}>free for 7 days</strong>.
                  </p>

                  <div className="hero-products-row">
                    {words.map((w, i) => (
                      <motion.div
                        key={w}
                        className="hero-product-chip"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: 0.8 + i * 0.15 }}
                      >
                        {w}
                      </motion.div>
                    ))}
                    <motion.div
                      className="hero-product-chip chip-more"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: 1.4 }}
                    >
                      +more
                    </motion.div>
                  </div>

                  <div className="hero-cta-row">
                    <HireUsModal />
                    <button className="btn btn-custom-outlined">
                      <Link to="/portfolio" className="btn-link">
                        Our Products
                      </Link>
                    </button>
                  </div>
                </motion.div>
              </Col>

              <Col xs={12} md={6} className="hero-right-col">
                <motion.div
                  className="hero-graphic"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1, delay: 0.4 }}
                >
                  <div className="orbit-ring ring-1">
                    <div className="orbit-dot dot-1" />
                  </div>
                  <div className="orbit-ring ring-2">
                    <div className="orbit-dot dot-2" />
                  </div>
                  <div className="orbit-ring ring-3">
                    <div className="orbit-dot dot-3" />
                  </div>
                  <div className="hero-center-icon">
                    <div className="center-pulse" />
                    <div className="center-icon-inner">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="20" stroke="#63FFCD" strokeWidth="1.5" />
                        <path d="M16 24h16M24 16v16" stroke="#63FFCD" strokeWidth="2" strokeLinecap="round" />
                        <circle cx="24" cy="24" r="4" fill="#63FFCD" />
                      </svg>
                    </div>
                  </div>
                  <div className="floating-card card-lms">
                    <span className="fcard-label">LMS</span>
                    <span className="fcard-tag">AI</span>
                  </div>
                  <div className="floating-card card-hms">
                    <span className="fcard-label">HMS</span>
                    <span className="fcard-tag">AI</span>
                  </div>
                  <div className="floating-card card-erp">
                    <span className="fcard-label">ERP</span>
                    <span className="fcard-tag">AI</span>
                  </div>
                </motion.div>
              </Col>
            </Row>
          </div>
        </div>
        
        {/* Scroll Indicator and Wave Transition */}
        <div className="hero-scroll-area">
          <motion.div 
            className="scroll-indicator"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 2, duration: 1 }}
          >
            <motion.div 
              className="scroll-mouse"
              animate={{ y: [0, 10, 0] }}
              transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            >
              <div className="scroll-wheel" />
            </motion.div>
            <span>Scroll Discover</span>
          </motion.div>

          <div className="hero-wave-wrap">
            <svg className="hero-wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
              <motion.path 
                initial={{ d: "M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" }}
                animate={{ 
                  d: [
                    "M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                    "M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,149.3C672,149,768,203,864,224C960,245,1056,235,1152,208C1248,181,1344,139,1392,117.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                    "M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                  ]
                }}
                transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
                fill="#ffffff" 
              />
            </svg>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default TopBgComponent;
